<div class="header">
    <div id="textbox" class="show-pointer">
        <p class="alignleft" [routerLink]="goToHome ? ['/home']: ['/home']">
            <!-- <img src="assets/search.svg"> -->
            <img src="assets/Logo.svg" alt="logo">
            <span class="logo">{{headerTitle}}</span>
        </p>
        <div class="flex-container" [sqTooltip]="fullName | sqMessage">   
            <div>{{userId}}</div>
        </div>
        <div class="es-logo">
            <span>
                <a class="footer-img" href="https://search.astrazeneca.com" target="_blank"><span >powered By</span><img  alt="Enterprise Search" src="assets/es-logo.png"></a>
            </span>
        </div>
        <!-- <div class="badge">JD</div> -->
        <div style="clear: both;"></div>
    </div>
</div>